export const mainServerAppUrl = process.env.REACT_APP_BACKEND;
export const serverAppUrl = process.env.REACT_APP_BACKEND_URL;
